import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="gk-footer">
            <div className="gk-footer-container">

                {/* Top Section: Logo, Socials & Newsletter */}
                <div className="gk-footer-top">

                    {/* Brand & Socials */}
                    <div className="gk-brand-column">
                        <Link to="/" className="gk-footer-logo" onClick={() => window.scrollTo(0, 0)} aria-label="Skill Ascent Home">
                            <img src="../images/logo.png" alt="Skill Ascent - Online Skill Development Institute" style={{ maxHeight: '70px', borderRadius: '8px' }} />
                        </Link>


                        <div className="gk-social-icons">
                            <a href="https://www.facebook.com/DbsSkillascent" target="_blank" rel="noopener noreferrer" className="gk-social-link"><i className="fab fa-facebook-f"></i></a>
                            <a href="https://www.instagram.com/dbs_skillascent/" target="_blank" rel="noopener noreferrer" className="gk-social-link"><i className="fab fa-instagram"></i></a>
                            <a href="http://youtube.com/post/UgkxgUqog4VnG8URQEleWA2gbSsqlgRn-9jT?si=dbf_k_281vVb5Tp_" target="_blank" rel="noopener noreferrer" className="gk-social-link"><i className="fab fa-youtube"></i></a>
                            <a href="https://www.linkedin.com/company/skill-ascent?trk=blended-typeahead" target="_blank" rel="noopener noreferrer" className="gk-social-link"><i className="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>

                    {/* About Us Description */}
                    <div className="gk-newsletter-column">
                        {/* <h3 className="gk-newsletter-title">About Skill Ascent</h3> */}
                        <p className="gk-newsletter-desc">
                            Skill Ascent is an innovative online learning platform dedicated to empowering learners with the skills and knowledge needed to succeed in today’s fast-changing digital world. We specialize in providing high-quality training across a diverse range of fields, including IT, Agriculture, Engineering, Creative & Business, and Healthcare courses designed to help students and professionals build successful careers.
                        </p>
                    </div>
                </div>

                <div className="gk-footer-divider"></div>

                {/* Middle Section: Links Grid */}
                <div className="gk-footer-links">

                    {/* Column 1: Courses */}
                    <div className="gk-link-group">
                        <h4 className="gk-link-header">Courses</h4>
                        <ul>
                            <li><Link to="/courses" state={{ category: "IT Courses" }} onClick={() => window.scrollTo(0, 0)}>IT Courses</Link></li>
                            <li><Link to="/courses" state={{ category: "Agriculture Courses" }} onClick={() => window.scrollTo(0, 0)}>Agriculture</Link></li>
                            <li><Link to="/courses" state={{ category: "Mechanical Courses" }} onClick={() => window.scrollTo(0, 0)}>Engineering</Link></li>
                            <li><Link to="/courses" state={{ category: "Creative & Business Courses" }} onClick={() => window.scrollTo(0, 0)}>Creative & Business</Link></li>
                            <li><Link to="/courses" state={{ category: "Healthcare Courses" }} onClick={() => window.scrollTo(0, 0)}>Healthcare</Link></li>
                        </ul>
                    </div>

                    {/* Column 2: Company */}
                    <div className="gk-link-group">
                        <h4 className="gk-link-header">Company</h4>
                        <ul>
                            <li><Link to="/online-skill-development-courses-india" onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
                            <li><Link to="/get-in-touch-skill-ascent" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link></li>
                        </ul>
                    </div>

                    {/* Column 3: Info */}
                    <div className="gk-link-group">
                        <h4 className="gk-link-header">Info</h4>
                        <ul>
                            <li><Link to="/return-policy" onClick={() => window.scrollTo(0, 0)}>Return Policy</Link></li>
                            <li><Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link></li>
                            <li><Link to="/terms-conditions" onClick={() => window.scrollTo(0, 0)}>Terms & Conditions</Link></li>
                        </ul>
                    </div>

                </div>

                <div className="gk-footer-divider"></div>

                {/* Bottom Section: Copyright & Legal */}
                <div className="gk-footer-bottom">
                    <p className="gk-copyright">© 2026 D Base Solutions Pvt. Ltd. All rights reserved.</p>
                    {/* <div className="gk-legal-links">
                        <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>
                        <Link to="/terms-conditions" onClick={() => window.scrollTo(0, 0)}>Terms & Conditions</Link>
                    </div> */}
                </div>

            </div>
        </footer>
    );
};

export default Footer;